import * as React from 'react'

type SetState<S, K extends keyof S> = (state: Pick<S, K>, callback?: () => any) => void

export function createSetStateAsync<S, K extends keyof S>(setState: SetState<S, K>) {
    return (state: Pick<S, K>) => new Promise<void>((resolve) => setState(state, resolve))
}

/**
 * A getter and mutating async setter
 */
export type StateLens<V> = {
    get: () => V
    set: (v: V) => Promise<void>
}

/**
 * Creates a getter and setter for react state
 */
export function createStateLens<S extends { [k in K]: S[K] }, K extends keyof S>(
    component: React.Component<unknown, S>,
    key: K
): StateLens<S[K]> {
    return {
        get: () => component.state[key],
        set: (value: S[K]) => new Promise((resolve) => component.setState({ [key]: value } as any, resolve)),
    }
}

type AsyncEffect = () => Promise<void>

export function useAsyncEffect(effect: AsyncEffect, dependencyList: React.DependencyList) {
    React.useEffect(() => {
        effect()
    }, dependencyList)
}
